import { memo } from "react";

import { FeatureIslandHeader } from "@/components/features/_layouts";

export const ECSalesSearchHeader = memo(() => {
	const title = "ECの販売管理";

	return <FeatureIslandHeader title={title} />;
});

ECSalesSearchHeader.displayName = "ECSalesSearchHeader";
